import React, { Component } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import QRCode from "qrcode.react";
import { Button } from "reactstrap";
import AuthService from "../../utils/auth.service";
import ShowValue from "../../components/ShowValue";
import ApiTransfer from "../../utils/api.transfer";
import MessageModal from "../../components/Message";
import Loading from "../../components/Loading";

class ProfileWalletPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      profile: AuthService.currentUser,
      transfer: {
        tax: 7500
      },
      modal: {
        isOpen: false,
        title: "",
        message: ""
      },
      loading: false,
      assetMessage: ""
    };

    this.handleInputTransfer = this.handleInputTransfer.bind(this);
    this.handleSubmitTransfer = this.handleSubmitTransfer.bind(this);
    this.setMessage = this.setMessage.bind(this);
    this.onCopy = this.onCopy.bind(this);
    this.setMessage = this.setMessage.bind(this);
    this.toggleAlert = this.toggleAlert.bind(this);
    this.handleBack = this.handleBack.bind(this);
  }

  handleBack() {
    this.props.history.goBack();
  }

  handleInputTransfer(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    let transfer = this.state.transfer;
    if (name === "value") {
      transfer[name] = Number(value);
    } else {
      transfer[name] = value;
    }

    this.setState(...this.state, { transfer: transfer });
  }

  handleSubmitTransfer() {
    this.setState(...this.state, { loading: true });
    ApiTransfer.post(this.state.transfer).then(response => {
      if (response) {
        this.setState(...this.state, { transfer: {} });
        let title = "Transfer made with success";
        if (response.data.status !== 201) {
          title = "Transfer error";
        }
        this.setMessage(title, response.data.message);

        AuthService.refresh();
      }
      this.setState(...this.state, { loading: false });
    });
  }

  toggleAlert() {
    this.setState(...this.state, {
      modal: { isOpen: !this.state.modal.isOpen }
    });
  }

  onCopy() {
    this.setState(...this.state, {
      assetMessage: "Bitcoin address copied in your clipboard"
    });
  }

  setMessage(title, message) {
    this.setState(...this.state, {
      modal: {
        title: title,
        message: message,
        isOpen: true
      },
      loading: false
    });
  }

  render() {
    return (
      <section className="profile-page">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-8">
              <h4 className="pt-4">My Wallet</h4>
              <button
                onClick={this.handleBack}
                className="btn btn-outline-secondary float-right"
              >
                Back
              </button>{" "}
              {/* Back */}
              <hr />
            </div>
          </div>{" "}
          {/* Wallet header */}
          <div className="row justify-content-center">
            <div className="col-md-8">
              <h4 className="pt-4">Balances</h4>
              <hr />
            </div>
          </div>{" "}
          {/* Balances header */}
          <div className="row justify-content-center">
            <div className="col-md-3">
              <p className="text-center">
                Balance:
                <br />
                <strong>
                  <ShowValue btc={this.state.profile.btc_founds} />
                </strong>
              </p>
            </div>{" "}
            {/* Balance */}
            <div
              className="col-md-2"
              hidden={!this.state.profile.reserved_auction}
            >
              <p className="text-center">
                In Auction:
                <br />
                <strong>
                  <ShowValue btc={this.state.profile.reserved_auction} />
                </strong>
              </p>
            </div>{" "}
            {/* In Auction */}
            <div
              className="col-md-3"
              hidden={
                this.state.profile.btc_founds ==
                this.state.profile.btc_balance -
                  this.state.profile.reserved_auction
              }
            >
              <p className="text-center">
                Net Balance:
                <br />
                <strong>
                  <ShowValue
                    btc={
                      this.state.profile.btc_balance -
                      this.state.profile.reserved_auction
                    }
                  />
                </strong>
              </p>
            </div>
            {/* Net Balance */}
          </div>
          {/* Balances */}
          <div className="row justify-content-center">
            <div className="col-md-8">
              <h4 className="pt-4">Bitcoin Address</h4>
              <hr />
            </div>
          </div>{" "}
          {/* QR Code header */}
          <div className="row justify-content-center">
            <div className="col-md-2">
              <p className="text-center m-0 pb-2">
                Click on the QR Code to copy address.
              </p>
              <div
                className="d-block bg-secondary cursor-pointer p-3"
                title="Click to copy the bitcoin address to your clipboard"
              >
                <CopyToClipboard
                  onCopy={this.onCopy}
                  text={this.state.profile.lander_btc_address}
                >
                  <span hidden={!this.state.profile.lander_btc_address}>
                    <QRCode
                      value={"bitcoin:" + this.state.profile.lander_btc_address}
                    />
                  </span>
                </CopyToClipboard>
              </div>
              <p className="text-center pt-2">{this.state.assetMessage}</p>
            </div>
          </div>{" "}
          {/* QR Code */}
          <div className="row justify-content-center">
            <div className="col-md-8">
              <h4 className="pt-4">Transfers</h4>
              <hr />
            </div>
          </div>{" "}
          {/* Transfers header */}
          <div className="row justify-content-center">
            <div
              className={
                this.state.profile.tfa_active ? "col-md-3" : "col-md-5"
              }
            >
              <div className="form-group">
                <label htmlFor="address">Transfer To: </label>
                <input
                  type="text"
                  name="address"
                  placeholder="Type or paste the address"
                  className="form-control"
                  required
                  onChange={this.handleInputTransfer}
                  value={this.state.transfer.address}
                />
              </div>
            </div>{" "}
            {/* Transfer to */}
            <div className="col-md-3">
              <div className="form-group">
                <label htmlFor="value">
                  Value (fee: {this.state.transfer.tax})
                </label>
                <input
                  type="number"
                  name="value"
                  min="0"
                  max={this.state.profile.btc_founds - this.state.transfer.tax}
                  className="form-control"
                  required
                  onChange={this.handleInputTransfer}
                  value={this.state.transfer.value}
                />
                <span
                  className="text-muted float-left"
                  hidden={!this.state.transfer.value}
                >
                  Plus fee:
                  <ShowValue
                    btc={
                      Number(this.state.transfer.value) +
                      Number(this.state.transfer.tax)
                    }
                  />
                </span>
              </div>
            </div>{" "}
            {/* Value */}
            <div hidden={!this.state.profile.tfa_active} className="col-md-2">
              <div className="form-group">
                <label htmlFor="address">TFA Code: </label>
                <input
                  type="text"
                  name="code"
                  maxLength="7"
                  className="form-control"
                  onChange={this.handleInputTransfer}
                  value={this.state.transfer.code}
                />
              </div>
            </div>{" "}
            {/* Tfa */}
            <div className="col-md-8">
              <hr />
              <Button
                className="float-right"
                onClick={this.handleSubmitTransfer}
                hidden={
                  !this.state.transfer.address ||
                  !this.state.transfer.value ||
                  Number(this.state.transfer.value) < 10000
                }
                color="secondary ml-2"
                type="submit"
              >
                Send
              </Button>
            </div>{" "}
            {/* Send */}
          </div>
          <Loading active={this.state.loading} />
          <MessageModal
            isOpen={this.state.modal.title}
            toggle={this.toggleAlert}
            title={this.state.modal.title}
            message={this.state.modal.message}
          />
        </div>
      </section>
    );
  }
}

export default ProfileWalletPage;



// WEBPACK FOOTER //
// ./src/containers/ProfileWalletPage/index.js